module.exports = "https://www.gc-qa.gnp.com.mx/94d93e35bcec236f5af0900ae2ced042.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/circle-contratante.svg
// module id = 244
// module chunks = 0